import script from "./LoanOption.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoanOption.vue?vue&type=script&setup=true&lang=ts"

import "@/styles/loan-options.scss?vue&type=style&index=0&id=030b3a8d&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-030b3a8d"]])

export default __exports__